import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { secondhandAssetClassNameConfig } from './SecondhandAssetClass.name';

/** 中古資産区分のENUM */
enum SecondhandAssetClass {
  /** 通常資産 */
  normalAsset = '0',
  /** 中古資産 */
  secondhandAsset = '1',
}

const secondhandAssetClassMap = new Map([
  ['0', SecondhandAssetClass.normalAsset],
  ['1', SecondhandAssetClass.secondhandAsset],
]);

const rawValueToSecondhandAssetClass = rawValueToEnumWithDefault(
  secondhandAssetClassMap,
  SecondhandAssetClass.normalAsset,
);

const secondhandAssetClassToDisplay = enumToNameWithDefault(
  SecondhandAssetClass,
  secondhandAssetClassNameConfig,
);

const secondhandAssetClassToDisplayWithPrefix = enumToNameWithDefault(
  SecondhandAssetClass,
  secondhandAssetClassNameConfig,
  true,
);

export {
  SecondhandAssetClass,
  rawValueToSecondhandAssetClass,
  secondhandAssetClassToDisplay,
  secondhandAssetClassToDisplayWithPrefix,
};
